@for (line of lines; track $index) {
<p>
    @for (field of line; track $index) {
    {{ field }}
    }
</p>
}